module.exports = __webpack_public_path__ + "img/location.a536cf88.svg";